import React, { useState } from 'react';

const MOCK = [
  {id:1,referrer:'Marcus Williams',referred:'David Park',policy:'Auto Bundle',commission:240,status:'Paid',date:'2026-03-20'},
  {id:2,referrer:'Jennifer Adams',referred:'Lisa Thompson',policy:'Home Insurance',commission:150,status:'Pending',date:'2026-04-05'},
  {id:3,referrer:'John Rivera',referred:'Sarah Chen',policy:'Life Insurance',commission:320,status:'Earned',date:'2026-04-10'},
  {id:4,referrer:'Marcus Williams',referred:'ABC Logistics',policy:'Commercial Auto',commission:2214,status:'Earned',date:'2026-04-08'},
];
const sColor: Record<string,string> = {Paid:'bg-green-100 text-green-700',Pending:'bg-yellow-100 text-yellow-700',Earned:'bg-blue-100 text-blue-700'};

const ReferralSystem: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({referrer:'',referred:'',policy:''});
  const [refs, setRefs] = useState(MOCK);
  const total = refs.filter(r=>r.status!=='Pending').reduce((s,r)=>s+r.commission,0);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Referral System</h1>
        <button onClick={()=>setShowModal(true)} className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">+ Log Referral</button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[['Total Referrals',refs.length,'text-blue-600'],['Commissions Earned','$'+total.toLocaleString(),'text-green-600'],['Pending',refs.filter(r=>r.status==='Pending').length,'text-yellow-600'],['Top Referrer','Marcus W.','text-purple-600']].map(([l,v,c])=>(
          <div key={l as string} className="bg-white rounded-xl border border-gray-200 p-4"><p className="text-xs text-gray-500">{l}</p><p className={`text-2xl font-bold mt-1 ${c}`}>{v}</p></div>
        ))}
      </div>
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>{['Referrer','Referred Client','Policy','Commission','Status','Date'].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {refs.map(r=>(
              <tr key={r.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium text-gray-900">{r.referrer}</td>
                <td className="px-4 py-3 text-gray-600">{r.referred}</td>
                <td className="px-4 py-3 text-gray-600">{r.policy}</td>
                <td className="px-4 py-3 text-green-700 font-medium">${r.commission.toLocaleString()}</td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${sColor[r.status]}`}>{r.status}</span></td>
                <td className="px-4 py-3 text-gray-500">{r.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-semibold mb-4">Log Referral</h2>
            <div className="space-y-3">
              {[['referrer','Who referred (existing client)'],['referred','New client name'],['policy','Policy type']].map(([k,l])=>(
                <input key={k} placeholder={l} value={(form as any)[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
              ))}
            </div>
            <div className="flex gap-3 mt-4">
              <button onClick={()=>{if(form.referrer){setRefs(p=>[...p,{id:Date.now(),...form,commission:0,status:'Pending',date:new Date().toISOString().split('T')[0]}]);setShowModal(false);}}} className="flex-1 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700">Save</button>
              <button onClick={()=>setShowModal(false)} className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ReferralSystem;
